<template>
    <div class="app-main goods-list">

        
        <div class="top-bar">
            <el-input placeholder="输入商品名称或者条形码" v-model="value" @change="search()" style="width:210px;margin-right:20px;" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" style="width: 100%">
                <el-table-column label="商品图片" fixed align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.image_url" :src="scope.row.image_url" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"  align="center"  show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="name"  label="商品类型" align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.goods_type == 2">食品类型</span>
                        <span v-else-if="scope.row.goods_type == 3">服务类型</span>
                        <span v-else>普通商品</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="status" align="center" label="商品状态" >
                    <template slot-scope="scope">
                        <el-link type="danger"  v-if="scope.row.status == 5">已回收</el-link>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="updated_at"  align="center" label="操作时间" ></el-table-column> -->
                <el-table-column  prop="sales_volume" align="center" label="商品销量"  sortable>
                    <!-- <template slot-scope="scope">
                        <el-input v-model="scope.row.sales_volume" @change="handleSales(scope.row)" size="mini" style="width:80px" readonly></el-input>
                    </template> -->
                </el-table-column>
                <el-table-column prop="totalMoney"  align="center" label="商品操作" >
                    <template slot-scope="scope">
                        <div class="table-btns">
                            <el-button  @click="goodsDel(scope.row)" type="danger" plain size="mini" style="margin:5px 0 0 0">删除商品</el-button>
                            <el-button  @click="goodsEdit(scope.row, 4)" type="success" plain size="mini" style="margin:5px 0 0 0">恢复商品</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData"  layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="20" ></el-pagination>
        </el-card>



    </div>
</template>



<script>
/* eslint-disable */
import { goods_list, goods_status, goods_del } from '@/api/goods.js'

import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            value:'',
            tableData:[],
            table_load:false,
            checkData:[],
            total:0,
            page:1,
            goods_modal:false,
            sku:[],
            goodsId:'',                   //商品ID
            sku_title: '',
            sku_modal: false,
        }
    },
    methods: {

        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
                status:5,
            }
            if(this.value != ""){
                params.search = this.value;
            }
            goods_list(params).then(res => {
                console.log()
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }else{
                    this.tableData = [];
                    // this.$message.error('Error')
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },
        goodsDel(row) {
             this.$confirm(`此操作将彻底删除："${row.name}" 不可恢复, 是否继续?`, "提示", {
                type: "warning",
            }).then(() => {
                goods_del(row.id).then(res =>{
                    if(res) {
                        this.$message({message:'删除成功',type:'success'})
                        this.getData()
                    }
                })
            }).catch(() =>{

            })
        },
        goodsEdit(row,flag){
            let params = {
                status:flag
            }
            goods_status(row.id,params).then(res => {
                if(res){
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                console.log(err)
            })
        },
    },
    created(){
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.border-box {
    box-sizing: border-box;
}
.goods-list {
    .content {
        width: 100%;
        height: calc(100vh - 200px);
        .shopImg {
            width: 80px;
            height: 80px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .var-edit {
        width: 100%;
        padding: 30px 20px;
        margin: 1px 0 20px;
        text-align: center;
        background: #f5f5f5;
        box-sizing: border-box;
        .avatar-uploader{
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            width:60px;
            height: 60px;
            background: #fff;
        }
        .avatar-uploader:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 60px;
            height: 60px;
            line-height: 60px;
            text-align: center;
        }
        .avatar {
            width: 60px;
            height: 60px;
            display: block;
        }
        .varImg {   
            display: inline-block;
            width: 180px;
            height: 32px;
            line-height: 32px;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            background-color:#fff; 
            font-size: 12px;
            cursor: pointer;
            overflow: hidden;
        }
        .varBtn {
            display: inline-block;
            width: 100px;
            height: 32px;
            line-height: 32px;
            border: 1px solid #DCDFE6;
            border-radius: 4px;
            background-color:#fff; 
            font-size: 12px;
            cursor: pointer;
        }
        td {
            padding-bottom: 15px;
        }
    }
}
</style>
